var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Close",
    clipPath: "url(#clip0_1580_85103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63642 5.63604C5.77707 5.49539 5.96784 5.41637 6.16675 5.41637C6.36567 5.41637 6.55643 5.49539 6.69708 5.63604L12.0004 10.9393L17.3037 5.63604C17.4443 5.49539 17.6351 5.41637 17.834 5.41637C18.0329 5.41637 18.2237 5.49539 18.3643 5.63604C18.505 5.77669 18.584 5.96746 18.584 6.16637C18.584 6.36528 18.505 6.55605 18.3643 6.6967L13.061 12L18.3643 17.3033C18.505 17.444 18.584 17.6347 18.584 17.8336C18.584 18.0325 18.505 18.2233 18.3643 18.364C18.2237 18.5046 18.0329 18.5836 17.834 18.5836C17.6351 18.5836 17.4443 18.5046 17.3037 18.364L12.0004 13.0607L6.69708 18.364C6.55643 18.5046 6.36567 18.5836 6.16675 18.5836C5.96784 18.5836 5.77707 18.5046 5.63642 18.364C5.49577 18.2233 5.41675 18.0325 5.41675 17.8336C5.41675 17.6347 5.49577 17.444 5.63642 17.3033L10.9397 12L5.63642 6.6967C5.49577 6.55605 5.41675 6.36528 5.41675 6.16637C5.41675 5.96746 5.49577 5.77669 5.63642 5.63604Z",
    fill: "#1C2026"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_85103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.3ac8708fc9633fc5545f7836666726b5.svg";
export { ForwardRef as ReactComponent };